import { useState } from "react";
import { Chip, Box } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import useIsMobile from "../hooks/useIsMobile";
import DropdownButton from "../common/DropdownButton";
import { AvailableStatusOptions, StageValue } from "./workflowStates";

export default ({
  currentStage,
  accountType,
  disabled,
  dropdownButtonId,
  onClick,
  withComment,
}: {
  currentStage: StageValue;
  disabled: boolean;
  accountType: "advisor" | "member";
  dropdownButtonId?: string;
  onClick: (value: StageValue, holdDate?: string) => void;
  withComment: boolean;
}) => {
  const isMobile = useIsMobile();
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [holdDate, setHoldDate] = useState<Date | null>(null);

  // Status options for the dropdown button
  const statusOptions = AvailableStatusOptions(
    currentStage || "new",
    accountType,
    withComment,
  );

  const handleStageSelect = (value: StageValue) => {
    const formattedDate = holdDate ? holdDate.toLocaleDateString() : undefined;
    onClick(value, formattedDate);
    setShowDatePicker(false);
    setHoldDate(null);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        flexDirection: isMobile ? "column" : "row",
      }}
    >
      {showDatePicker && (
        <DatePicker
          value={holdDate}
          onChange={(newDate) => setHoldDate(newDate)}
          minDate={new Date()}
          sx={{
            ".MuiInputBase-input": {
              marginTop: "0",
            },
            ".MuiInputBase-root": {
              minHeight: "0",
            },
            "& .MuiInputBase-root": {
              height: "40px",
              fontSize: "12px",
              padding: "0 20px 0 8px",
            },
            "& .MuiInputBase-input": {
              padding: "6px 8px",
            },
          }}
          slotProps={{
            textField: {
              size: "small",
              placeholder: "Hold date (optional)",
              variant: "outlined",
            },
          }}
        />
      )}
      <DropdownButton
        key={currentStage}
        disabled={disabled}
        options={statusOptions.map((option) => ({
          label: (
            <Chip label={option.label} variant={option.variant} size="small" />
          ),
          value: option.value,
          selectedTitle: option.selectedTitle,
          onClick: (value) => {
            if (value === StageValue.OnHold) {
              setShowDatePicker(true);
            }
          },
        }))}
        initialValue={statusOptions?.[0].value}
        onClick={(value) => handleStageSelect(value as StageValue)}
        size="small"
        variant="outlined"
        sx={{
          button: {
            height: "33px",
          },
        }}
        dropdownButtonId={dropdownButtonId}
      />
    </Box>
  );
};
